import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  bienvenida: {
    width: "100%",
    height: "auto",
    overflow: "hidden",
    margin: "0",
    position: "relative",
  },
  imagenBienvenida: {
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    margin: "0",
    position: "relative",
  },
  imagenShadow: {
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.3)", // Ajusta la opacidad aquí
      zIndex: 1,
    },
  },
  bienvenida2: {
    width: "140%",
    height: "auto",
    overflow: "hidden",
    margin: "0",
    position: "relative",
  },
  logo2: {
    width: "100%",
    maxWidth: "450px",
    height: "auto",
    position: "absolute",
    top: "6rem",
    left: "0",
    right: "0",
    margin: "auto",
    zIndex: 2
  }
}));
